import React from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./WhatsappChatbot.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WhatsappChatbot = ({ phoneNumber, message }) => {
  const waLink = message
    ? `https://wa.me/${9096247296}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${9096247296}`;

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp_chatbot"
      aria-label="Chat with us on WhatsApp"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="whatsapp_icon" />
    </a>
  );
};

export default WhatsappChatbot;
